import Link from "next/link";
import React from "react";
import Rating from "./Rating";
import { numberWithCommas } from "@/utils/functions/function";
import { useRouter } from "next/router";

const PriceSection = ({ villa, listVilla }) => {
  const router = useRouter();

  let TemizlikFiyatlar = 0;
  let CleaningMaxDate = 0;
  let geceFark = villa?.geceFark || 0;
  let CleaningFee = 0;
  let isCleaningFee = false;

  if (villa?.sqfiyat && villa?.TemizlikFiyatlar) {
    TemizlikFiyatlar = villa?.TemizlikFiyatlar?.split("##");
    CleaningMaxDate = TemizlikFiyatlar[1] || 0;
    let isletter = parseInt(geceFark) < CleaningMaxDate;

    if (isletter && TemizlikFiyatlar[2]) {
      isCleaningFee = true;
      CleaningFee = TemizlikFiyatlar[2];
    }
  }

  const conditionalWidth =
    router.pathname === "/ProductCategory" ? "xlg:w-48" : "";
  return (
    <Link
      title={villa.title}
      href={villa.url || "#"}
      prefetch={false}
      className={`${
        listVilla
          ? "flex-col bg-[#E7EDF4] rounded-lg"
          : "bg-white rounded-b-2xl"
      } ${conditionalWidth} w-auto shrink-0 flex items-center xlg:p-5 p-3 drop-shadow-custom cursor-pointer`}
    >
      <div
        className={`${
          listVilla
            ? "xlg:flex-col flex-row h-full items-start"
            : "items-center"
        } flex  justify-between w-full`}
      >
        {listVilla && (
          <div className="hidden xlg:flex">
            <Rating rating={villa.rating} reviews={villa.reviews} />
          </div>
        )}
        <div className="flex flex-col">
          <div className="flex flex-row items-center gap-2 xlg:flex-col xlg:items-start xlg:gap-0">
            {villa?.minfiyat && (
              <>
                {villa?.IndirimTutari > 0 ? (
                  <>
                    <div className="flex flex-col">
                      <span className="text-sm font-medium leading-normal line-through text-themeSecondary">
                        {numberWithCommas(
                          parseFloat(villa?.indirimliMinFiyatOrg)
                        )}
                        {villa?.Symbol}
                      </span>
                      <span className="text-xl not-italic font-medium leading-normal text-themeBlack">
                        {numberWithCommas(villa?.indirimliMinFiyat)}
                        {villa?.Symbol}
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <span className="text-xl not-italic font-medium leading-normal text-themeBlack">
                      {villa?.Symbol}
                      {numberWithCommas(villa?.minfiyat)}
                    </span>
                  </>
                )}
                <span className="text-[#9CA5B0] text-size-11 font-medium leading-normal -tracking--letterS">
                  ‘den başlayan gecelik fiyatlar
                </span>
              </>
            )}

            {villa?.sqfiyat && (
              <>
                {villa?.IndirimTutari > 0 ? (
                  <span className="text-sm font-medium leading-normal line-through text-themeSecondary">
                    {numberWithCommas(
                      parseFloat(villa?.IndirimTutari) +
                        parseFloat(villa?.sqfiyat) +
                        parseFloat(CleaningFee)
                    )}
                    {villa?.Symbol}
                  </span>
                ) : (
                  ""
                )}

                <span className="text-xl not-italic font-medium leading-normal text-themeBlack">
                  {numberWithCommas(
                    parseFloat(villa?.sqfiyat) + parseFloat(CleaningFee)
                  )}
                  {villa?.Symbol}
                </span>
                {geceFark > 0 ? (
                  <span className="text-[#9CA5B0] text-size-11 font-medium leading-normal -tracking--letterS">
                    {geceFark} gece
                  </span>
                ) : (
                  ""
                )}

                {isCleaningFee ? (
                  <div className="mt-1 text-xs">
                    <span className="mr-1 font-bold transition-all duration-200 ease-in">
                      +{numberWithCommas(parseFloat(CleaningFee))}
                      {villa?.Symbol}
                    </span>
                    Kısa Süreli <br /> Konaklama Ücreti Dahildir
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
          </div>
        </div>
        <div
          className={`${
            listVilla
              ? "group-hover:bg-themeSecondColor transition-all ease-in-out duration-200"
              : ""
          } flex items-center justify-center py-3 px-4 rounded-[40px]  bg-[#9DADC0] text-white text-sm font-medium leading-normal transition-all ease-in-out duration-200 hover:bg-opacity-70`}
        >
          incele
        </div>
      </div>
    </Link>
  );
};

export default PriceSection;
